import React, { Component } from "react";
import { Table } from "antd";
import UserType from "@/enum/UserType";

/**
 * @deprecated
 */
export default class SeTable extends Component {
  constructor(props) {
    super(props);
    this.handleResize = this.handleResize.bind(this);
  }

  components = {
    header: {
      cell: this.ResizeableTitle,
    },
  };
  // 伸缩配置
  handleResize =
    (index) =>
    (e, { size }) => {
      this.setState(({ columns }) => {
        const nextColumns = [...columns];
        nextColumns[index] = {
          ...nextColumns[index],
          width: size.width,
        };
        return { columns: nextColumns };
      });
    };

  render() {
    const { data, columns, loading, onPageChange, userType } = this.props;
    const { PROVIDER, CONSUMER } = UserType;

    // 分页配置
    const pagination = {
      showQuickJumper: true,
      defaultPageSize: data.pageSize,
      showTotal: (total) => `总共 ${data.totalElements} 个项目`,
      showSizeChanger: true,
      pageSizeOptions: ["10", "50", "100", "200"],
      total: data.totalElements,
      current: data.pageNo,
      onChange: (current, pageSize) => {
        this.current = data.pageNo;
        this.pageSize = data.pageSize;
        onPageChange(current, pageSize);
      },
      onShowSizeChange: (current, pageSize) => {
        onPageChange(current, pageSize);
      },
    };

    return (
      <Table
        size="small"
        columns={columns}
        dataSource={data.content}
        loading={loading}
        rowKey={(record) => record.id}
        pagination={pagination}
        // pagination={userType === PROVIDER || userType === CONSUMER ? false : pagination}
      />
    );
  }
}
